import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/api/api-client.config';

const uploadUsers = ({
  id,
  bodyFormData,
}: {
  id: number;
  bodyFormData: FormData;
}) =>
  api.post(`/contests/${id}/upload-users`, bodyFormData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const useUploadParticipantsMutation = ({
  contestId,
}: {
  contestId: number;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['uploadParticipants', contestId],
    mutationFn: ({ bodyFormData }: { bodyFormData: FormData }) =>
      uploadUsers({ id: contestId, bodyFormData }),
    onSuccess: () => {
      toast.success('Participants uploaded successfully');

      queryClient.invalidateQueries({
        queryKey: ['contests', contestId, 'users'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
